import React from 'react'
import "../styles/getInTouch.css"
import phoneIcon from "../assets/img/c1.webp"
import calendarIcon from "../assets/img/c.webp"
import emailIcon from "../assets/img/c3.webp"
import whatsappIcon from "../assets/img/whatsapp-icon.png"
import Footer from '../components/Footer'
import Nav from '../components/Nav'
import { RiWhatsappFill } from "react-icons/ri";

const GetInTouch = () => {
  return (
    <>
        <div className='home__wrapper'>

    <Nav/>
    <section className="contact-wrapper">
  <h2 className="contact-title">Get in Touch</h2>
  <div className="contact-options">
    <div className="contact-box">
      <img src={phoneIcon} alt="Call Icon" />
      <h4>Call Us</h4>
      <p>Need urgent assistance?</p>
<a href="tel:+254746878028">
  <button type="button" className="contact-btn">
    Call Now <span>+</span>
  </button>
</a>
    </div>
 

<div className="contact-box">
  <img src={whatsappIcon} alt="WhatsApp Icon" />
  <h4>Chat on WhatsApp</h4>
  <p>Prefer messaging instead?</p>
  <a 
    href="https://wa.me/254746878028" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <button type="button" className="contact-btn">
      Start a Chat <span>+</span>
    </button>
  </a>
</div>
  
    <div className="contact-box">
      <img src={calendarIcon} alt="Calendar Icon" />
      <h4>Book a Free Discovery Call</h4>
      <p>A quick chat to understand your needs.</p>
      <a href='/booking-form'  > 
  <button type="button" className="contact-btn">
   Schedule Call <span>+</span>
  </button>
   </a>
    </div>
    <div className="contact-box">
      <img src={emailIcon} alt="Email Icon" />
      <h4>Submit an Enquiry</h4>
      <p>Prefer to share details first?</p>
      <a href='/enquiry-form' > 
  <button type="button" className="contact-btn">
   Send Enquiry <span>+</span>
  </button> 
  </a>   
    </div>
  </div>
</section>
 </div>
<Footer/>

    </>
  )
}

export default GetInTouch